import React from 'react';
import { theme } from '../../../Theme';
import { styled } from 'linaria/react';
import { ReactComponent as AngleDown } from '../../../../svg/AngleDown.svg';

const ButtonWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  right: 2rem;
  ${theme.below.sm} {
    right: 0.75rem;
  }
`;

const Button = styled('button')`
  position: relative;
  background: transparent;
  border: 1px solid #e0e0e0;
  width: 100%;
  cursor: pointer;
  text-align: left;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  outline: none;
  margin-bottom: 20px;

  justify-content: space-between;
  font-size: 11px;
  letter-spacing: 0.03rem;
  color: #333333;
  font-weight: bold;
  padding: 9px 10px;

  p {
    transition: all 0.2s ease;
    padding-right: 10px;
  }
  svg {
    width: 15px;
    height: 20px;
  }
`;

const FilterButton = ({ showTarget }) => {
  return (
    <ButtonWrapper>
      <Button onClick={showTarget}>
        Filter / Sorter etter
        <AngleDown />
      </Button>
    </ButtonWrapper>
  );
};

export default FilterButton;
